export const addMissingProfileMenuStyles = {
	option: {
		display: 'flex',
		flexDirection: 'row',
		gap: 1
	}
};
